var _defs, _g, _g2, _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500px",
    height: "500px",
    viewBox: "0 0 200 200",
    style: {
      overflow: "hidden!important"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1007"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2907",
    cx: 100,
    cy: 114,
    r: 41,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2908",
    stopOpacity: 0.5,
    stopColor: "#ffe4d6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2909",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2911",
    cx: 100,
    cy: 54,
    r: 37,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2912",
    stopOpacity: 0.5,
    stopColor: "#ffe4d6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2913",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3114",
    x1: 100,
    y1: 172,
    x2: 100,
    y2: 133,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-chinshadow-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3115",
    stopOpacity: 0.8,
    stopColor: "#e1ac8f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3116",
    stopOpacity: 1,
    stopColor: "#c27b55",
    offset: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3123",
    x1: 100,
    y1: 144,
    x2: 100,
    y2: 141,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-mouth-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3124",
    stopOpacity: 1,
    stopColor: "#e8b9a0",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3125",
    stopOpacity: 1,
    stopColor: "#e1ac8f",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3353",
    cx: 126.452,
    cy: 84.563,
    r: 15.179,
    gradientTransform: "matrix(-0.9148 0.0479 0.0523 0.9986 184.4328 -6.6013)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3354",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3355",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3356",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3357",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3358",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3359",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3361",
    cx: 126.017,
    cy: 84.585,
    r: 15.179,
    gradientTransform: "matrix(0.9148 0.0479 -0.0523 0.9986 15.5672 -6.6013)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3362",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3363",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3364",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3365",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3366",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3367",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3369",
    cx: 126.452,
    cy: 84.563,
    r: 15.179,
    gradientTransform: "matrix(-0.9148 0.0479 0.0523 0.9986 184.4328 -6.6013)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3370",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3371",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3372",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3373",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3374",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3375",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3379",
    cx: 122.781,
    cy: 80.48,
    fx: 136.429,
    fy: 80.114,
    r: 16.914,
    gradientTransform: "matrix(0.99 0.1411 0.1085 -0.7608 -53.0622 124.3787)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3380",
    stopOpacity: 1,
    stopColor: "#e1ac8f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3381",
    stopOpacity: 0.3,
    stopColor: "#e1ac8f",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3382",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3384",
    cx: 70.049,
    cy: 105.782,
    r: 29.51,
    gradientTransform: "matrix(1.0336 0 0 1.0336 -1.9413 1.255)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3385",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3386",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3390",
    cx: 126.017,
    cy: 84.585,
    r: 15.179,
    gradientTransform: "matrix(0.9148 0.0479 -0.0523 0.9986 15.5672 -6.6013)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3391",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3392",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3393",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3394",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3395",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3396",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3400",
    cx: 122.382,
    cy: 80.48,
    fx: 136.03,
    fy: 80.114,
    r: 16.914,
    gradientTransform: "matrix(-0.99 0.1411 -0.1085 -0.7608 252.2674 124.4351)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3401",
    stopOpacity: 1,
    stopColor: "#e1ac8f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3402",
    stopOpacity: 0.3,
    stopColor: "#e1ac8f",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3403",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3405",
    cx: 70.436,
    cy: 105.782,
    r: 29.51,
    gradientTransform: "matrix(-1.0336 0 0 1.0336 201.9413 1.255)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3406",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3407",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3412",
    cx: -568.659,
    cy: -521.042,
    r: 59.751,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 141.2814 119.9893)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3413",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3414",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3416",
    cx: -582.838,
    cy: -519.099,
    r: 59.745,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 131.1134 135.9855)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3417",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3418",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3422",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3423",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3424",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3426",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3427",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3428",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3430",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3431",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3432",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3435",
    cx: -568.654,
    cy: -521.042,
    r: 59.752,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 193.2804 119.9894)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3436",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3437",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3439",
    cx: -582.833,
    cy: -519.102,
    r: 59.747,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 183.1126 135.9856)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3440",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3441",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3445",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3446",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3447",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3449",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3450",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3451",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3453",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3454",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3455",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-wrapper"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-backs-single"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3752",
    d: "M100.5,100.5h-1v-1h1V100.5z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2914",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2915",
    d: "M159.156 184.058c24.342 3.542 34.586 8.708 37.794 50.721H200c0-12.5-0.877-26.992-4.583-35 -2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-18.242-12.069-21.643-16.35 3.36 4.704 12.791 15.605 21.054 18.46C150.188 182.61 153.48 183.232 159.156 184.058zM53.766 181.244c8.263-2.854 17.693-13.756 21.054-18.46 -3.4 4.28-16.114 15.054-21.643 16.35 -6.896 1.615-25.494 4.619-33.733 7.022 -6.665 1.942-12.664 8.876-14.86 13.622 -3.706 8.008-4.583 22.5-4.583 35h3.05c3.188-41.744 13.475-47.183 37.794-50.721C46.52 183.232 49.813 182.61 53.766 181.244z",
    fill: "#ffe4d6",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2916",
    d: "M95.646 197.62c0 0-5.074-1.609-7.083-2.379 -10.449-4.009-44.395-6.607-44.395-6.607s35.754 1.419 43.644 2.779c-0.458-4.767-3.017-20.004-3.017-20.004s5.149 16.815 6.409 21.057C91.878 194.734 95.646 197.62 95.646 197.62zM106.445 196.278c-0.089 0.073-0.191 0.168-0.302 0.268C106.256 196.461 106.358 196.372 106.445 196.278zM95.646 197.62c0 0 2.893 2.992 4.347 3.03 1.91 0.051 4.828-2.899 6.151-4.104 -1.265 0.957-4.159 1.391-5.31 1.436C99.504 198.033 95.646 197.62 95.646 197.62zM116.664 190.101c-1.545 0.248-4.386 0.789-4.386 0.789l2.287-14.89c-0.646 3.071-4.474 16.211-8.12 20.278 1.91-1.616 6.158-2.391 8.324-2.704 10.236-1.484 10.232-1.483 41.062-4.94C155.831 188.634 126.76 188.479 116.664 190.101z",
    fill: "#e1ac8f",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2917",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "none",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-chinshadow-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3113",
    d: "M124.253 159.292c0.209-6.588 1.387-16.822 2.44-24.934 -15.046-2.317-38.404-2.272-53.372 0.112 1.041 8.028 2.198 18.103 2.419 24.664 8.455 6.921 18.045 12.742 24.414 12.731C106.453 171.856 115.887 166.136 124.253 159.292z",
    fill: "url(#SvgjsLinearGradient3114)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-clothes-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3883",
    d: "M42.77 235.757l1.323-60.852c0 0 10.194-2.487 16.635-6.313 17.496 21.953 69.451 17.333 78.336-0.62 1.489 0.525 2.721 1.197 4.262 1.713 5 3.386 9.213 4.494 9.213 4.494l0.935 61.685C139.188 236.052 42.77 235.757 42.77 235.757z",
    fill: "#f5f4f5",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3884",
    d: "M154.014 177.705c-4.236-0.719-7.611-1.697-9.452-3.544 -5.343 10.025-26.763 16.378-33.855 17.309 20.554-6.276 29.188-10.813 32.598-21.583 1.99 2.383 6.522 3.549 12.313 4.538L154.014 177.705zM52.67 174.381c1.454-0.312 2.18-1.234 3.623-1.593l-1.528-1.867c-3.114 2.234-8.971 3.305-15.9 4.424l0.188 3.738c3.956-0.79 7.817-1.788 11.429-3.323 7.483 8.485 19.168 12.659 31.06 14.387C66.624 186.562 58.07 180.511 52.67 174.381z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3885",
    d: "M137.861 170.055c-5.929 11.361-50.74 24.595-76.009 0.866 -1.571 0.615-6.271 2.085-6.271 2.085 18.406 23.08 72.345 23.227 86.702-0.112C142.221 172.87 139.321 170.737 137.861 170.055z",
    fill: "#dfdde2",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3886",
    d: "M139.008 167.841c-10.087 18.575-62.578 21.204-78.239 0.625 -5.72 1.556-11.219 4.876-16.756 5.707l-1.243 61.584 110.703 0.107 -0.855-62.386c-3.369-0.707-6.501-2.737-9.254-3.894C141.842 168.945 140.55 168.37 139.008 167.841zM60.39 169.087c13.903 23.086 68.817 18.455 79.419 0.099 1.286 0.499 1.615 0.696 3.106 1.183 -10.982 21.208-65.306 27.967-87.525 1.147C55.546 171.476 58.823 169.629 60.39 169.087zM54.287 172.418c17.963 27.046 77.26 22.856 89.583-1.287 1.771 1.391 4.53 2.989 7.936 3.735l1.66 59.08 -110.377 0.016 1.904-58.299C47.777 174.264 52.247 173.232 54.287 172.418z",
    fill: "#b8b6c9",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3887",
    d: "M-4.529 235.566c-2.574-13.852-2.292-47.592 9.013-47.521 13.136-5.311 29.269-11.404 42.802-15.311 6.908-7.246 13.436-14.137 26.188-21.314 0.389 2.599 1.874 8.541 0.011 11.773 -1.355 2.352-5.783 5.576-9.554 8.368 -2.029 2.72-3.927 5.374-6.599 9.089 5.168 22.301 9.601 33.78 10.097 53.123 0 0-1.452 0.689 64.471 0.397 2.215-22.339 4.993-33.561 10.379-54.098 0 0-4.308-5.014-7.207-8.87 -2.054-1.997-8.36-7.532-8.84-8.651 -1.175-2.741-0.548-6.188 0.11-11.367 10.793 4.873 17 12.021 26.082 21.303 7.729 2.119 30.86 9.967 42.445 15.216 3.965-0.11 6.203 1.999 7.872 5.466 5.405 11.195 4.126 27.297 2.18 42.789C185.83 235.989 49.887 238.17-4.529 235.566z",
    fill: "#335529",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3888",
    d: "M73.875 154.081c0.16 1.07 0.304 2.085 0.411 3.041 -0.218 0.266-17.212 23.353-17.336 23.525C61.126 171.148 67.1 161.305 73.875 154.081zM126.053 154.081c-0.159 1.07-0.184 2.085-0.291 3.041 0.218 0.266 16.931 22.469 17.054 22.642C138.391 170.914 132.828 161.305 126.053 154.081zM165.008 185.154c-4.28 6.231-5.194 8.382-9.879 14.557 1.071 0 2.799 0.166 3.87 0.166C162.663 193.592 162.67 190.393 165.008 185.154zM169.394 230.379c3.793-8.9 6.934-16.711 10.739-25.624l-1.247-2.014C175.717 211.896 172.354 221.199 169.394 230.379zM41.048 199.877c1.071 0 2.799-0.166 3.871-0.166 -4.685-6.175-5.599-6.561-9.878-12.792C37.377 192.158 37.384 193.592 41.048 199.877zM21.161 202.741l-1.247 2.014c3.806 8.913 4.765 16.724 8.559 25.624C25.512 221.199 24.33 211.896 21.161 202.741z",
    fill: "#24461b",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3889",
    d: "M65.638 169.283c1.181-1.646 5.237-7.272 8.601-12.561C75.227 162.179 73.413 165.416 65.638 169.283zM125.74 156.36c2.553 4.396 5.562 8.772 8.664 12.803C126 165.336 125.435 161.423 125.74 156.36z",
    fill: "#18360f",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3890",
    d: "M126.318 151.359c0.008-0.061 0.017-0.118 0.023-0.174 18.093 9.999 28.576 25.02 40.747 36.217 -0.448 0.721-1.228 1.193-1.687 1.905C152.656 179.609 146.599 164.946 126.318 151.359zM71.736 152.022c-15.034 8.213-36.242 33.357-38.318 35.269 0.448 0.724 0.691 0.577 1.15 1.288C47.314 178.882 50.793 169.283 71.736 152.022zM194.869 187.704c-1-0.799-24.646-10.039-42.59-14.969 33.698 16.299 45.587 18.545 51.471 24.321C203.367 196.057 202.586 187.489 194.869 187.704zM47.458 172.555c-13.524 3.914-30.839 10.098-42.975 15.491 -5.364 0.106-9.208 7.93-10.031 16.084C1.914 187.317-1.773 198.62 47.458 172.555z",
    fill: "#44643a",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3891",
    d: "M206.6 210.062c-0.34-8.635-3.055-23.103-11.691-22.46 -0.714-0.61-20.822-9.767-42.285-15.611 -7.353-7.455-16.515-17.598-26.371-20.957 -0.711 6.428-1.477 10.622 0.216 12.714 2.241 2.439 4.93 4.879 7.568 6.522 4.616 6.136 8.139 9.778 8.139 9.778 -5.43 20.703-8.815 31.314-10.973 53.688H68.798c-2.157-22.373-5.543-32.984-10.973-53.688 0 0 3.522-3.643 8.139-9.778 2.639-1.644 5.327-4.083 7.568-6.522 1.692-2.092 0.927-6.286 0.216-12.714 -9.856 3.359-19.019 13.502-26.371 20.957 -21.463 5.845-41.571 15.001-42.285 15.611 -8.637-0.643-11.352 13.825-11.691 22.46 -0.411 10.487 1.435 24.938 1.585 25.938h210.029C205.165 234.999 207.011 220.549 206.6 210.062zM72.984 163.194c-2.258 2.233-3.658 3.181-6.473 5.282 4.829-6.271 4.341-5.433 7.708-11.229C74.37 159.739 73.433 162.751 72.984 163.194zM-3.172 234.028c-1.082-12.844-2.916-24.41 0.43-36.992 1.281-4.827 2.484-8.095 7.455-8.509 1.067 5.538 8.132 28.724 14.298 44.533 -6.226-24.192-5.311-18.81-8.219-28.452 -0.964-3.235-1.854-6.486-2.979-9.672 -0.783-2.214-1.65-4.387-2.262-6.653l40.433-14.865c-0.279 0.283-12.895 13.434-13.199 13.804 1.847 3.021 7.816 7.222 10.845 11.758 -12.436 1.174-18.508 3.173-23 3.84 0.331 0.919 9.061 25.353 9.976 27.656 -1.479-7.917-4.816-20.297-8.637-27.211 1.41-0.179 18.077-2.492 23.393-3.477 -1.476-2.854-8.043-8.437-11.559-12.619 20.646-18.162 25.422-27.402 39.593-35.454 0.15 1.509 0.443 3.011 0.55 4.519 -15.795 23.533-17.649 23.567-17.649 23.567 4.585 17.81 10.532 35.824 10.532 54.073L-3.172 234.028zM127.016 163.194c-0.448-0.443-1.386-3.455-1.235-5.947 3.367 5.797 2.879 4.958 7.708 11.229C130.674 166.375 129.273 165.428 127.016 163.194zM203.172 234.028l-70-0.154c0-18.249 5.947-36.264 10.532-54.073 0 0-1.854-0.034-17.649-23.567 0.106-1.508 0.399-3.01 0.55-4.519 14.171 8.052 18.946 17.292 39.593 35.454 -3.516 4.183-10.083 9.766-11.559 12.619 5.315 0.984 21.982 3.298 23.393 3.477 -3.82 6.914-7.157 19.294-8.637 27.211 0.915-2.304 9.645-26.737 9.976-27.656 -4.492-0.667-10.564-2.666-23-3.84 3.028-4.536 8.998-8.736 10.845-11.758 -0.305-0.37-12.92-13.521-13.199-13.804 0.001 0 40.433 14.865 40.433 14.865 -0.611 2.267-1.479 4.439-2.262 6.653 -1.125 3.186-2.015 6.437-2.979 9.672 -2.908 9.643-1.993 4.26-8.219 28.452 6.166-15.81 13.23-38.995 14.298-44.533 4.971 0.414 6.174 3.682 7.455 8.509C206.088 209.618 204.254 221.185 203.172 234.028z",
    fill: "#0e2707",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-head",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2927",
    d: "M45.671 84.344c-1.485-2.462-6.327-9.199-10.031-8.254 -3.012 0.772-2.973 4.971-3.206 7.455 -0.34 3.644-0.464 9.992 0.525 12.568 0.951 2.473 3.96 7.252 5.828 9.075 2.299 2.235 5.97 9.358 6.422 10.097 0.711 1.168 2.137 2.84 4.325 2.708 3.071-0.185 5.724-3.087 5.965-4.485C56.8 105.918 49.536 90.75 45.671 84.344z",
    fill: "#f0c7b1",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2928",
    d: "M44.2 99.341c-0.143-0.563 0.007-1.513 0.154-2.429 0.133-0.835 0.258-1.624 0.182-2.182 -0.289-2.09-1.915-6.06-2.976-8.212 -1.223-2.476-3.199-5.595-5.679-6.399 -1.024-0.333-1.699 0.065-2.089 0.468 -0.288 0.296-0.353 0.645-0.259 0.687 0.095 0.041 0.307-0.248 0.617-0.519 0.254-0.222-0.508-0.04 0 0 -0.205 1.04-0.865 6.302-0.41 10.143 0.358 3.022 1.05 5.279 1.263 5.617 0.031 0.356 0.083 0.705 0.16 1.043 1.002 4.41 7.518 10.177 9.034 11.82 0.28 0.303 0.574 0.483 0.646 0.409s-0.101-0.373-0.379-0.678c-1.498-1.632-7.971-7.381-8.939-11.635 -1.027-4.514 3.912-11.207 4.699-12.623 0.401 0.665 0.742 1.303 1.004 1.835 0.207 0.417 0.434 0.906 0.67 1.435 -0.463 0.738-5.118 6.127-3.934 10.441 0.438 1.591 3.822 3.642 5.131 4.203 0.72 0.31 0.99 0.772 1.304 1.306 0.364 0.624 0.033 2.229 1.23 2.739 0.244 0.104 0.464 0.146 0.659 0.146 0.338 0 0.594-0.13 0.783-0.284 0.02 0.271 0.019 0.619 0.009 0.941 -0.012 0.418 0.047 0.609 0.148 0.617 0.103 0.009 0.21-0.174 0.223-0.587 0.017-0.51 0.014-1.141-0.077-1.444 -0.269-0.889-1.088-1.894-1.957-2.957C44.563 102.197 44.422 100.213 44.2 99.341zM34.969 95.432c-2.348-6.923 1.283-13.229 1.81-14.179 1.012 0.399 2.562 2.193 3.221 3.235C39.52 85.321 35.067 90.775 34.969 95.432zM45.772 106.464c-1.084-0.462-0.706-1.984-1.056-2.584 -0.318-0.542-0.646-1.102-1.479-1.46 -0.18-0.078-0.379-0.196-0.583-0.332 -2.682-6.075 0.293-8.73 1.039-9.273 0.229 0.742 0.399 1.423 0.476 1.97 0.068 0.5-0.059 1.298-0.181 2.068 -0.153 0.955-0.31 1.944-0.147 2.584 0.244 0.953 0.411 2.97 1.291 4.048 0.781 0.956 1.583 1.942 1.857 2.746C46.871 106.391 46.5 106.775 45.772 106.464z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2929",
    d: "M154.066 84.344c1.486-2.462 6.328-9.199 10.031-8.254 3.012 0.772 2.973 4.971 3.207 7.455 0.34 3.644 0.463 9.992-0.525 12.568 -0.951 2.473-3.961 7.252-5.828 9.075 -2.299 2.235-5.971 9.358-6.422 10.097 -0.711 1.168-2.137 2.84-4.326 2.708 -3.07-0.185-5.723-3.087-5.965-4.485C142.938 105.918 150.203 90.75 154.066 84.344z",
    fill: "#f0c7b1",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2930",
    d: "M154.322 103.243c-0.869 1.063-1.688 2.068-1.957 2.957 -0.092 0.304-0.094 0.935-0.078 1.444 0.014 0.413 0.121 0.596 0.225 0.587 0.102-0.008 0.16-0.199 0.148-0.617 -0.01-0.322-0.012-0.67 0.008-0.941 0.189 0.154 0.445 0.284 0.783 0.284 0.195 0 0.416-0.042 0.66-0.146 1.195-0.511 0.865-2.116 1.229-2.739 0.314-0.534 0.584-0.997 1.305-1.306 1.309-0.561 4.693-2.611 5.131-4.203 1.184-4.314-3.471-9.704-3.934-10.441 0.234-0.529 0.463-1.018 0.668-1.435 0.264-0.532 0.604-1.171 1.006-1.835 0.787 1.416 5.725 8.108 4.699 12.623 -0.969 4.254-7.441 10.003-8.939 11.635 -0.279 0.305-0.453 0.604-0.381 0.678 0.074 0.074 0.367-0.106 0.646-0.409 1.516-1.643 8.031-7.41 9.033-11.82 0.078-0.338 0.131-0.687 0.162-1.043 0.211-0.337 0.904-2.594 1.262-5.617 0.455-3.841-0.205-9.103-0.41-10.143 0.508-0.04-0.254-0.222 0 0 0.311 0.271 0.523 0.56 0.617 0.519 0.094-0.042 0.029-0.39-0.258-0.687 -0.391-0.403-1.066-0.801-2.09-0.468 -2.48 0.804-4.457 3.923-5.68 6.399 -1.061 2.152-2.686 6.122-2.975 8.212 -0.076 0.558 0.049 1.347 0.182 2.182 0.146 0.916 0.297 1.866 0.154 2.429C155.316 100.213 155.176 102.197 154.322 103.243zM159.738 84.488c0.66-1.042 2.209-2.835 3.221-3.235 0.527 0.95 4.158 7.256 1.811 14.179C164.672 90.775 160.219 85.321 159.738 84.488zM152.75 106.229c0.273-0.804 1.076-1.79 1.857-2.746 0.879-1.078 1.047-3.095 1.291-4.048 0.162-0.64 0.006-1.629-0.146-2.584 -0.123-0.77-0.25-1.568-0.182-2.068 0.076-0.547 0.246-1.228 0.475-1.97 0.746 0.543 3.721 3.199 1.039 9.273 -0.203 0.136-0.402 0.254-0.584 0.332 -0.832 0.358-1.16 0.918-1.479 1.46 -0.35 0.6 0.029 2.123-1.055 2.584C153.238 106.775 152.867 106.391 152.75 106.229z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-wrap",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3110",
    d: "M158.918 78.006l-0.005 0c-0.012 0.054-9.983 41.375-18.186 54.159 -6.452 10.056-28.899 29.684-40.573 29.701 -11.671 0.021-34.17-19.539-40.652-29.576 -8.242-12.758-18.353-54.042-18.365-54.096h-0.001c-1.298-4.992-1.994-10.231-2.002-15.634C39.082 28.536 66.289 0.92 99.907 0.867c33.621-0.053 60.913 27.476 60.963 61.499C160.879 67.769 160.201 73.01 158.918 78.006z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3111",
    d: "M124.597 6.119c18.568 10.001 31.371 30.966 31.404 55.247 0.008 5.403-0.616 10.644-1.796 15.641l-0.005 0c-0.011 0.054-9.185 41.375-16.73 54.159 -5.937 10.056-26.588 29.684-37.327 29.701 -10.737 0.021-31.437-19.539-37.4-29.576 -7.582-12.758-16.885-54.042-16.896-54.096h-0.001c-1.195-4.992-1.835-10.231-1.842-15.634C43.969 37.217 56.775 16.161 75.391 6.126 54.006 15.706 39.096 37.37 39.134 62.56c0.008 5.403 0.704 10.643 2.002 15.634h0.001c0.012 0.054 10.123 41.338 18.365 54.096 6.482 10.037 28.981 29.597 40.652 29.576 11.673-0.018 34.121-19.646 40.573-29.701 8.202-12.784 18.174-54.105 18.186-54.159l0.005 0c1.283-4.997 1.961-10.237 1.952-15.641C160.833 37.238 145.928 15.667 124.597 6.119z",
    fill: "#e8b9a0",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3112",
    d: "M158.918 78.006l-0.005 0c-0.012 0.054-9.983 41.375-18.186 54.159 -6.452 10.056-28.899 29.684-40.573 29.701 -11.671 0.021-34.17-19.539-40.652-29.576 -8.242-12.758-18.353-54.042-18.365-54.096h-0.001c-1.298-4.992-1.994-10.231-2.002-15.634C39.082 28.536 66.289 0.92 99.907 0.867c33.621-0.053 60.913 27.476 60.963 61.499C160.879 67.769 160.201 73.01 158.918 78.006z",
    fill: "none",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3122",
    d: "M99.983 144.169c-3.24 0-4.753-2.8-4.753-2.8s4.797 0.78 9.279-0.067C104.509 141.302 102.832 144.169 99.983 144.169z",
    fill: "url(#SvgjsLinearGradient3123)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3126",
    d: "M99.869 138.7c-8.472 0-12.247-2.608-15.517-6h31.035C112.672 136.172 108.709 138.7 99.869 138.7z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3127",
    d: "M99.869 138.7c-8.472 0-12.247-2.608-15.517-6h31.035C112.672 136.172 108.709 138.7 99.869 138.7z",
    fill: "none",
    stroke: "#c27b55",
    strokeWidth: 0.75,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3352",
    d: "M60.432 80.957c1.226-1.179 9.091-2.674 13.631-2.075 7.183 0.947 13 7.285 13 7.285s-4.836 3.083-13.61 3.56C67.673 90.042 61.86 86.309 60.432 80.957z",
    fill: "url(#SvgjsRadialGradient3353)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-left",
    transform: "matrix(1,0,0,1,0.25,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3506",
    d: "M80 84c0 3.313-2.687 5.999-6 5.999S68 87.313 68 84c0-3.316 2.687-6.001 6-6.001S80 80.685 80 84z",
    fill: "#7b5c33",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3507",
    d: "M70.512 86.805c0.875-0.072 0.1-0.306 0.1-0.306 -0.433-0.233-1.248-0.592-1.248-0.921 0-1.031 1.414-1.299-0.034-1.705 -1.504-1.38 1.167-1.352 1.147-1.398 -0.975-2.376 0.299-1.071 0.835-1.773 1.988-2.599 0.554 0.267 1.633 0 0.391-0.096-0.78-1.531 0.034-1.33 0.539 0.132 0.662 0.58 0.662 0.58 0.393-0.077 1.008-0.682 1.008-0.682 0.749 0.226 1.275 1.29 1.043 1.091 0.368-0.045 0.884-0.221 1.286-0.341 0 0 0.07-0.239 0.139-0.033 0.917 2.661 3.284 2.47 0.559 3.24 0 0-0.176 0 0.382 0.442 2.71 2.164-2.102 1.495 0.451 2.49 0.104-0.104-1.53 0.965-1.53 1.261 0 0.501-1.042 1.818-1.946 1.3 -0.504-0.288-0.581 0.6-0.877 0.19 -0.581-0.803-1.742-0.035-1.313-0.773 0.634-0.521-0.654 0.204-0.904 0.204 -0.828 0 1.083-2.783 3.894-0.715 0.822 0.602-0.864-1.433 0.625-1.433 0.149 0.049 0.104-0.521 0.104-0.682 -0.774-0.151 1.39-0.003 1.39-1.262 0.137 0.027 0.509-0.35-1.635 0 0 0-0.068-0.75-0.034-0.886 0.11-0.438 1.214-0.298 0.904-0.75 0-0.001-0.799-1.604-0.799-1.604 -2.573-0.414-1.102-0.672-2.711-0.341 -0.076 0.378-3.445 1.984-3.338 2.729 0.1 0.702 2.115 0.938 0.208 2.182C73.405 91.051 68.437 85.454 70.512 86.805z",
    fill: "#8a6d47",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3508",
    d: "M74 78.749l0.171 4.393 1.837-3.993 -1.523 4.123 3.227-2.985 -2.985 3.226 4.124-1.523 -3.992 1.839 4.392 0.17 -4.392 0.17 3.992 1.839 -4.124-1.523 2.985 3.226 -3.227-2.985 1.523 4.123 -1.837-3.993L74 89.249l-0.171-4.393 -1.838 3.993 1.522-4.123 -3.226 2.985 2.985-3.226 -4.124 1.523 3.992-1.839 -4.39-0.17 4.39-0.17 -3.992-1.839 4.124 1.523 -2.985-3.226 3.226 2.985 -1.522-4.123 1.838 3.993L74 78.749z",
    fill: "#5c3d14",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3509",
    d: "M74.796 80.067l-0.539 3.315 1.981-2.711 -1.766 2.857 2.87-1.748 -2.725 1.964 3.319-0.515L74.668 84l3.266 0.794 -3.317-0.538 2.712 1.982 -2.858-1.765 1.748 2.869 -1.964-2.725 0.516 3.319 -0.771-3.27 -0.795 3.264 0.539-3.315 -1.984 2.711 1.768-2.857 -2.869 1.748 2.725-1.964 -3.319 0.516 3.269-0.771 -3.264-0.793 3.315 0.537 -2.712-1.982 2.858 1.765 -1.747-2.869 1.964 2.725 -0.516-3.318 0.772 3.27L74.796 80.067z",
    fill: "#4d3009",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3510",
    d: "M76.25 84c0 1.243-1.008 2.25-2.25 2.25s-2.25-1.007-2.25-2.25 1.008-2.25 2.25-2.25S76.25 82.757 76.25 84z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3511",
    d: "M71.637 88.311c-0.331 0.332-0.985 0.215-1.46-0.261 -0.476-0.475-0.593-1.129-0.261-1.461 0.331-0.331 0.985-0.214 1.46 0.261C71.852 87.326 71.969 87.979 71.637 88.311z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3512",
    d: "M78.806 82.818c-0.496 0.496-1.697 0.1-2.682-0.886 -0.986-0.986-1.382-2.187-0.886-2.683 0.496-0.496 1.697-0.1 2.682 0.886C78.906 81.122 79.302 82.322 78.806 82.818z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.9
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3377",
    d: "M55.132 85c0 13.808 12.668 20.999 18 20.999 9.94 0 18-7.191 18-20.999 0-13.809-8.06-25.001-18-25.001S55.132 71.191 55.132 85zM60.432 80.957c1.226-1.179 9.091-2.674 13.631-2.075 7.183 0.947 13 7.285 13 7.285s-4.836 3.083-13.61 3.56C67.673 90.042 61.86 86.309 60.432 80.957z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3378",
    d: "M73.981 93.592c9.412 2.223 18.451-1.61 20.194-8.565 1.738-6.956-4.478-14.395-13.892-16.622 -9.414-2.224-18.453 1.609-20.195 8.565C58.35 83.927 64.564 91.365 73.981 93.592zM60.432 80.957c1.226-1.179 9.091-2.674 13.631-2.075 7.183 0.947 13 7.285 13 7.285s-4.836 3.083-13.61 3.56C67.673 90.042 61.86 86.309 60.432 80.957z",
    fill: "url(#SvgjsRadialGradient3379)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3383",
    d: "M60.432 80.957c1.226-1.179 9.091-2.674 13.631-2.075 7.183 0.947 13 7.285 13 7.285s-4.836 3.083-13.61 3.56C67.673 90.042 61.86 86.309 60.432 80.957z",
    fill: "url(#SvgjsRadialGradient3384)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3387",
    d: "M86.632 82.458c-6.502-4.251-4.054-3.09-16.23-6.703 3.344 0.5 9.572 2.066 11.707 3.32C83.272 79.729 85.632 81.584 86.632 82.458z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3388",
    d: "M58.853 80.886c1.947 4.926 9.734 13.961 29.285 5.533 -3.097-3.36-11.005-9.113-18.159-9.063C63.986 77.397 60.637 79.265 58.853 80.886zM60.432 81.074c1.226-1.137 9.091-2.58 13.631-2.001 7.183 0.913 13 7.026 13 7.026s-4.836 2.974-13.61 3.434C67.673 89.836 61.86 86.236 60.432 81.074z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3360",
    d: "M139.169 80.957c-1.226-1.179-9.091-2.674-13.631-2.075 -7.183 0.947-13 7.285-13 7.285s4.836 3.083 13.61 3.56C131.928 90.042 137.74 86.309 139.169 80.957z",
    fill: "url(#SvgjsRadialGradient3361)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-right",
    transform: "matrix(1,0,0,1,-0.25,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3513",
    d: "M132,83.999c0,3.316-2.684,6-6,6s-6-2.684-6-6s2.684-6,6-6S132,80.683,132,83.999z",
    fill: "#7b5c33",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3514",
    d: "M122.508 86.806c0.879-0.076 0.105-0.305 0.105-0.305 -0.434-0.234-1.254-0.592-1.254-0.926 0-1.031 1.418-1.295-0.023-1.705 -1.512-1.377 1.16-1.348 1.137-1.395 -0.973-2.379 0.305-1.072 0.844-1.775 1.98-2.596 0.551 0.27 1.629 0 0.387-0.094-0.785-1.529 0.035-1.33 0.539 0.135 0.656 0.58 0.656 0.58 0.398-0.076 1.008-0.68 1.008-0.68 0.75 0.223 1.277 1.289 1.043 1.09 0.375-0.047 0.891-0.223 1.289-0.34 0 0 0.07-0.24 0.141-0.035 0.914 2.66 3.281 2.473 0.563 3.24 0 0-0.176 0 0.375 0.439 2.707 2.168-2.098 1.494 0.457 2.49 0.105-0.1-1.535 0.967-1.535 1.266 0 0.498-1.043 1.816-1.945 1.295 -0.504-0.287-0.586 0.604-0.879 0.193 -0.574-0.803-1.746-0.035-1.313-0.773 0.633-0.521-0.656 0.205-0.902 0.205 -0.832 0 1.078-2.783 3.891-0.715 0.82 0.598-0.867-1.436 0.633-1.436 0.141 0.047 0.105-0.521 0.105-0.68 -0.785-0.152 1.383-0.006 1.383-1.266 0.141 0.029 0.516-0.346-1.629 0 0 0-0.07-0.75-0.035-0.885 0.105-0.439 1.207-0.299 0.902-0.75l-0.797-1.605c-2.578-0.41-1.102-0.668-2.719-0.34 -0.07 0.381-3.445 1.986-3.34 2.73 0.105 0.703 2.121 0.938 0.211 2.18C125.402 91.054 120.434 85.452 122.508 86.806z",
    fill: "#8a6d47",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3515",
    d: "M126 78.749l0.176 4.395 1.828-3.996 -1.523 4.125 3.234-2.988 -2.988 3.229 4.125-1.523 -3.996 1.84 4.395 0.17 -4.395 0.17 3.996 1.84 -4.125-1.523 2.988 3.229 -3.234-2.988 1.523 4.125 -1.828-3.996L126 89.249l-0.176-4.395 -1.84 3.996 1.523-4.125 -3.223 2.988 2.988-3.229 -4.125 1.523 3.996-1.84 -4.395-0.17 4.395-0.17 -3.996-1.84 4.125 1.523 -2.988-3.229 3.223 2.988 -1.523-4.125 1.84 3.996L126 78.749z",
    fill: "#5c3d14",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3516",
    d: "M126.797 80.067l-0.539 3.316 1.98-2.713 -1.77 2.859 2.871-1.752 -2.719 1.969 3.316-0.516 -3.27 0.768 3.27 0.797 -3.316-0.539 2.707 1.98 -2.859-1.764 1.746 2.871 -1.957-2.725 0.516 3.316L126 84.667l-0.797 3.264 0.539-3.316 -1.98 2.713 1.77-2.859 -2.871 1.752 2.719-1.969 -3.316 0.516 3.27-0.768 -3.27-0.797 3.316 0.539 -2.707-1.98 2.859 1.764 -1.746-2.871 1.957 2.725 -0.516-3.316 0.773 3.27L126.797 80.067z",
    fill: "#4d3009",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3517",
    d: "M128.25 83.999c0 1.242-1.008 2.25-2.25 2.25s-2.25-1.008-2.25-2.25 1.008-2.25 2.25-2.25S128.25 82.757 128.25 83.999z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3518",
    d: "M123.633 88.312c-0.328 0.328-0.984 0.217-1.453-0.264 -0.48-0.475-0.598-1.125-0.258-1.459 0.328-0.328 0.984-0.211 1.453 0.264C123.855 87.327 123.973 87.978 123.633 88.312z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3519",
    d: "M130.805 82.815c-0.492 0.498-1.699 0.105-2.684-0.885 -0.984-0.984-1.383-2.186-0.879-2.678 0.492-0.498 1.688-0.105 2.672 0.885C130.91 81.122 131.297 82.323 130.805 82.815z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.9
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3398",
    d: "M126.469 59.999c-9.94 0-18 11.193-18 25.001 0 13.808 8.06 20.999 18 20.999 7.201 0 18-7.191 18-20.999C144.469 71.191 136.409 59.999 126.469 59.999zM126.148 89.727c-8.774-0.476-13.61-3.56-13.61-3.56s5.817-6.338 13-7.285c4.54-0.6 12.405 0.896 13.631 2.075C137.74 86.309 131.928 90.042 126.148 89.727z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3399",
    d: "M139.512 76.971c-1.742-6.956-10.781-10.79-20.195-8.565 -9.414 2.227-15.63 9.666-13.892 16.622 1.743 6.955 10.782 10.788 20.194 8.565C135.036 91.365 141.251 83.927 139.512 76.971zM126.148 89.727c-8.774-0.476-13.61-3.56-13.61-3.56s5.817-6.338 13-7.285c4.54-0.6 12.405 0.896 13.631 2.075C137.74 86.309 131.928 90.042 126.148 89.727z",
    fill: "url(#SvgjsRadialGradient3400)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3404",
    d: "M139.169 80.957c-1.226-1.179-9.091-2.674-13.631-2.075 -7.183 0.947-13 7.285-13 7.285s4.836 3.083 13.61 3.56C131.928 90.042 137.74 86.309 139.169 80.957z",
    fill: "url(#SvgjsRadialGradient3405)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3408",
    d: "M112.969 82.458c6.502-4.251 4.054-3.09 16.23-6.703 -3.344 0.5-9.572 2.066-11.707 3.32C116.328 79.729 113.969 81.584 112.969 82.458z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3409",
    d: "M129.622 77.355c-7.154-0.05-15.063 5.703-18.159 9.063 19.551 8.428 27.338-0.607 29.285-5.533C138.964 79.265 135.614 77.397 129.622 77.355zM126.148 89.533c-8.774-0.459-13.61-3.434-13.61-3.434s5.817-6.113 13-7.026c4.54-0.579 12.405 0.864 13.631 2.001C137.74 86.236 131.928 89.836 126.148 89.533z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-facehighlight-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2906",
    d: "M141 113.974c0.035 22.622-18.292 40.994-40.938 41.025 -22.642 0.037-41.028-18.273-41.063-40.9 -0.035-22.62 18.292-41.064 40.937-41.1C122.579 72.964 140.967 91.349 141 113.974z",
    fill: "url(#SvgjsRadialGradient2907)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2910",
    d: "M137.5 53.999c0 20.711-16.789 37.5-37.499 37.5 -20.711 0-37.501-16.789-37.501-37.5s16.79-37.5 37.501-37.5C120.711 16.499 137.5 33.288 137.5 53.999z",
    fill: "url(#SvgjsRadialGradient2911)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-rotate",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3520",
    d: "M54 74.189c9.954-9.974 16.761-5.915 30.589-3.264 0.845 0.162 6.32 1.539 5.31 3.469 -0.483 0.924-2.036 0.814-2.903 0.798C73.308 74.936 66.652 65.197 54 74.189z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-rotate",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3521",
    d: "M146 74.189c-9.953-9.974-16.761-5.915-30.589-3.264 -0.846 0.162-6.32 1.539-5.311 3.469 0.483 0.924 2.036 0.814 2.903 0.798C126.691 74.936 133.348 65.197 146 74.189z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3044",
    d: "M91.115 115.499c-0.878 2.064 5.934 4.292 8.519 4.429 2.8 0.147 10.646-2.9 9.316-4.992 -1.399-2.195-6.643-0.286-8.906-0.286C97.792 114.649 92.291 112.745 91.115 115.499z",
    fill: "#e1ac8f",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3045",
    d: "M101.857 117.058c-0.23-0.759 1.876-1.584 2.657-1.694 1.101-0.16 3.36 0.802 3.158 1.592 -0.184 0.698-2.148-0.533-2.86-0.429C104.078 116.634 102.075 117.769 101.857 117.058zM94.974 116.811c0.968 0 2.404 0.623 2.668 0.074 0.315-0.655-2.139-1.461-2.86-1.372 -0.596 0.07-2.733 1.315-2.439 1.839C92.617 117.833 93.698 116.811 94.974 116.811z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3046",
    d: "M100.089 111.999c0.607 0 1.742-0.74 1.792-2.23 0.201-6.008-0.956-23.833-1.792-23.77 -0.78 0.059-2.267 17.637-1.948 23.77C98.22 111.271 99.404 111.999 100.089 111.999z",
    fill: "#fff5ef",
    strokeWidth: "none",
    opacity: 0.2,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beardwrap",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3858",
    d: "M72.42 160.26c-5.81-3.72-13.18-11.11-15.9-14.77 -7.66-9.79-4.66-17.95-8.53-35.15 -1.98-7.5-5.26-18.5-5.66-21.25 0.92 0.14 5.78 0.8 6.6 0.93 1.2 9.39 11.79 16.08 13.6 35.39 1.59 12.14 7.59 18.02 17.41 24.08 4.16 2.58 12.18 6.78 14.08 2.24 1.54-3.67-1.1-11.12 5.3-12.33 1.33-0.24 4.18 0.28 5.27 2.75 1.75 3.96-0.91 11.56 4.76 11.56 5.88 0 16.02-7.55 18.85-10.16 11.11-9.12 7.48-20.17 12.58-32.27 5.89-13.04 7.72-11.36 10.27-21.27 0.69-0.07 5.9-0.83 6.6-0.92 -4.17 16.98-7.48 25.21-7.92 35.96 -0.79 15.97-5.59 21-16.37 30.85 -6.03 5.19-13.51 10.32-32.37 11.08C95.57 167.34 80.1 165.31 72.42 160.26z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3859",
    d: "M95.38 142.31c0.62-1.45 1.76-2.59 3.93-3 1.36-0.24 4.28 0.3 5.38 2.81 0.04 0.08 0.06 0.17 0.09 0.25C103.09 143.86 100.5 152.4 95.38 142.31zM141 142c-8.07 14.34-22.56 22.25-38.44 22.3 -1.25 0.07-3.54 0.1-5.11 0C81.56 164.25 67.07 156.34 59 142c-9.23-13.84-7.39-31.09-14.91-45.45 1.19 4.32 2.7 9.59 3.81 13.82 3.87 17.19 0.87 25.38 8.55 35.19 2.81 3.78 10.16 11.1 15.92 14.79 7.31 4.8 21.46 6.87 27.63 6.78 6.17 0.09 20.33-1.97 27.63-6.78 5.76-3.69 13.11-11.01 15.92-14.79 7.68-9.81 4.68-18 8.55-35.19 1.11-4.23 2.62-9.5 3.81-13.82C148.39 110.91 150.23 128.16 141 142z",
    fill: "#1b141c",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3860",
    d: "M150.98 89.93c-2.55 9.97-4.37 8.25-10.28 21.33 -5.13 12.16-1.46 23.13-12.56 32.24 -2.78 2.56-14.58 11.41-20.12 9.97 -3.83-1.42-1.7-7.65-3.33-11.34 -1.1-2.51-4.02-3.05-5.38-2.81 -6.46 1.22-3.85 8.77-5.37 12.39 -1.87 4.45-9.86 0.24-13.94-2.29 -10.08-6.22-15.82-12.25-17.36-24.01 -1.82-19.41-12.46-26.06-13.61-35.47 -0.1-0.02-6.7-0.92-6.81-0.96 0.31 2.51 3.65 13.7 5.68 21.39 3.87 17.19 0.87 25.38 8.55 35.19 2.81 3.78 10.16 11.1 15.92 14.79 7.74 5.09 23.16 7.11 28.64 6.74 18.77-0.76 26.34-5.87 32.43-11.11 10.96-10.02 15.62-15.01 16.4-30.92 0.44-10.78 3.73-18.87 7.95-36.08C157.74 88.98 151.22 89.93 150.98 89.93zM148.16 124.87c-1.33 16.05-4.59 19.53-15.46 29.44 -7.73 6.67-15.89 10.48-32.74 11.68 -7.52-0.57-20.89-3.02-27.2-7.45 -6.56-4.44-13.32-11.94-15.07-14.32 -7.22-9.27-3.76-17.8-8.36-34.18 -3.01-9.46-4.51-12.5-6.94-20.78 1 0.14 3.37 0.62 6.56 0.93 1.35 10.67 10.52 15.97 12.17 35.34 0.35 2.32 0.77 6.86 4.03 12.27 1.66 2.8 3.82 5.3 5.7 6.85 5.59 5.16 24.18 17.39 24.44 4.11 0.04-3.62-0.46-8.59 4.72-9.35 8.73 1.24 1.26 13.05 7.76 15.11 6.22 1.75 27.12-8.89 30.41-24.98 1.7-6.03-0.87-10.33 8.5-28.01 2.48-4.5 3.69-6.57 4.38-11.34 1.23-0.12 5.73-0.7 6.56-0.94C153.92 101.69 148.85 113.11 148.16 124.87z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3846",
    d: "M80.56 143.19c-7.87-11.92 1.64-21.9 10.5-21.9 3.27 0 5.65 1.63 8.98 1.65 3.11 0 6.01-1.58 9.11-1.49 6.34 0 14.64 5.28 13.09 13.41 -0.5 2.55-1.58 4.88-2.76 7.65 -2.9-13.79-9.32-10.74-21.95-11.35 -5.81-0.28-11.06-0.54-14.67 4.44C81.42 137.83 80.65 141.46 80.56 143.19",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3847",
    d: "M114.64 122.65c6.79 5.52 7.15 10.66 5.4 15.4 -0.54-6.99-7.47-13.3-20.26-10.03C86.98 124 80.33 131.2 79.7 138.9c-0.94-5.92 0.12-12.47 7.58-17.01 -7.52 2.33-13.72 11.17-6.62 21.62 0-1.41 0.73-5.43 2.29-7.85 3.98-5.49 9.98-4.55 16.6-4.3 9.78 0.62 16.95-2.77 19.86 11.28 0.01 0.08 0.03 0.15 0.05 0.22 0.08-0.18 0.16-0.38 0.25-0.59 0.04-0.1 0.09-0.2 0.13-0.31 0.97-2.27 2.02-4.56 2.51-7.06C123.48 128.87 119.34 124.62 114.64 122.65z",
    fill: "#1b141c",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3848",
    d: "M109.15 121.36c-3.11-0.11-6.08 1.52-9.23 1.48 -2.44-0.05-4.81-1.07-6.76-1.45 -9.31-1.81-21.46 8.97-12.51 22.12 0-1.41 0.73-5.43 2.29-7.85 3.98-5.49 9.98-4.55 16.6-4.3 9.78 0.62 16.95-2.77 19.86 11.28 0.01 0.08 0.03 0.15 0.05 0.22 0.08-0.18 0.16-0.38 0.25-0.59 0.04-0.1 0.09-0.2 0.13-0.31 0.97-2.27 2.02-4.56 2.51-7.06C123.93 126.52 115.3 121.36 109.15 121.36zM119.66 141.92c-1.54-14.71-12.16-11.49-20.06-11.91 -5.88-0.22-10.44-0.85-14.95 2.23 -3.33 2.74-4.26 6.2-4.26 10.61 -7.32-12.58 4.24-22.14 12.55-20.57 3.98 0.87 5.66 2.25 10.84 0.96 1.21-0.3 4.72-1.27 6.2-0.9 5.17 0.42 10.29 4.09 11.59 8.08C122.85 134.19 120.53 139.41 119.66 141.92z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-front",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3754",
    d: "M158.43 41.325C140-4.765 100 0.405 100 0.405s-40-5.169-58.43 40.92c-9.245 23.12 2.158 50.324 2.158 50.324h5.826c-5.094-21.752 0.796-17.662 1.176-21.722 0.118-1.255-0.3-3.367-0.421-4.622 -0.592-6.112 1.982-18.029 5.245-23.173 1.603-2.526 5.369-6.659 8.174-7.699 9.97-3.694 20.044 0.715 22.854 1.421 4.461 1.12 22.373 1.12 26.836 0 3.343-0.839 13.182-4.905 22.854-1.321 2.806 1.04 6.871 4.972 8.474 7.499 3.263 5.144 5.537 16.16 4.945 22.272 -0.121 1.255-0.539 4.367-0.422 5.623 0.107 1.147 2.617 3.689 2.898 4.807 1.16 4.612-1.722 16.915-1.722 16.915h5.825C156.271 91.649 167.676 64.445 158.43 41.325z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3755",
    d: "M154.938 31.163C136.178-3.114 101.979-0.631 100-0.455c-1.979-0.176-36.177-2.659-54.938 31.618C30.57 57.641 41.57 88.137 42.907 91.612c0.076 0.197 1.576 0.038 1.576 0.038 -0.006-0.015-0.104-0.392-0.166-0.55 -1.209-3.12-12.189-33.18 2.061-59.216C65.111-2.342 99.595 1.007 99.94 1.046L100 0.504l0.06 0.542c0.345-0.039 34.829-3.388 53.563 30.837 14.563 26.61 2.773 57.423 1.996 59.383 -0.021 0.055-0.107 0.375-0.111 0.383 0 0 1.506 0.169 1.575-0.011C158.374 88.294 169.467 57.709 154.938 31.163z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3569",
    d: "M142.29 97.41c-4.18 2.89-9.99 4.5-16.48 3.86 -10.05-0.98-16.01-7.51-18.24-13.28 -1.93-4.85-1.14-8.25 2.64-11.36 2.87-2.36 8.27-4.17 14.16-4.76C135.43 75.65 145.22 86.87 142.29 97.41zM67.01 71.94c-6.66 0.84-12.69 3.67-15.12 9.47 -4.22 10.71 7.21 21.33 22.29 19.86 4.2-0.41 7.68-1.8 10.48-3.69C87.73 87.06 78.04 75.82 67.01 71.94z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3570",
    d: "M142.29 97.41c2.93-10.54-6.86-21.75-17.91-25.54 9.5-0.95 20.27 1.28 23.73 9.54C150.51 87.51 147.83 93.58 142.29 97.41zM89.78 76.62c-4.25-3.5-14.06-5.79-22.77-4.68 11.03 3.88 20.72 15.12 17.65 25.64 3.89-2.63 6.46-6.23 7.76-9.6C94.36 83.14 93.57 79.74 89.78 76.62z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3571",
    d: "M153.71 83.76c-0.2-0.95-0.69-2.01-1.04-2.35 -0.7-0.7-2.57-1.14-3.87-1.19 -6.82-14.51-37.85-11.21-42.69-0.22 -3.34-1.97-8.87-1.98-12.23 0 -4.85-11-35.88-14.29-42.69 0.22 -1.3 0.05-3.17 0.49-3.87 1.19 -0.34 0.34-0.84 1.4-1.04 2.35 -0.13 0.63-0.6 1.16-0.44 1.53 0.44 1 1.33 0.38 1.71 0.13 0.29-0.1 1.55 0.06 2.36 0.69 0.08 9.47 10.7 17.59 24.38 16.25 13.97-1.36 21.1-13.38 20.15-20.44 1.91-1.42 9.19-1.43 11.11 0 -0.95 7.05 6.18 19.07 20.15 20.44 13.67 1.34 24.3-6.78 24.38-16.25 0.81-0.63 2.06-0.79 2.36-0.69 0.38 0.25 1.28 0.87 1.72-0.13C154.31 84.92 153.84 84.39 153.71 83.76zM50.03 84.34c-0.7-0.33-1.46-0.53-2.11-0.53 0.14-0.52 0.37-1.11 0.53-1.27 0.26-0.26 1.12-0.64 2.07-0.61C50.28 82.71 50.12 83.52 50.03 84.34zM91.98 87.81c-2.16 5.6-7.98 12.01-17.83 12.98 -14.85 1.45-25.84-8.92-21.8-19.2 0.1-0.24 0.15-0.35 0.22-0.54C58.11 68.82 82.13 70.96 89.48 77 92.8 79.73 93.99 82.75 91.98 87.81zM125.86 100.79c-9.85-0.96-15.68-7.38-17.84-12.98 -2.02-5.06-0.82-8.08 2.5-10.81 7.35-6.04 31.36-8.17 36.91 4.04 0.07 0.2 0.13 0.3 0.22 0.54C151.7 91.86 140.7 102.24 125.86 100.79zM149.97 84.34c-0.1-0.82-0.25-1.63-0.49-2.41 0.95-0.03 1.81 0.34 2.07 0.61 0.16 0.17 0.39 0.75 0.53 1.27C151.43 83.82 150.67 84.01 149.97 84.34z",
    fill: "#26120b",
    strokeWidth: "none",
    opacity: 1
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "SvgjsRect1057",
    width: 200,
    height: 15,
    x: 0,
    y: 185,
    fill: "#ecf0f1",
    opacity: 0.5,
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "SvgjsText1058",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontSize: "10px",
    textAnchor: "start",
    fontWeight: 400,
    anchor: "start",
    fill: "#333333",
    x: 38.749820709228516,
    y: 182.42831206321716,
    style: {
      display: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "SvgjsTspan1059",
    dy: 13,
    x: 38.749820709228516
  }, "Created on svgAvatars.com")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAvatar);
export default __webpack_public_path__ + "static/media/myAvatar.c07f2ac1591c236c6eb56a312705d76e.svg";
export { ForwardRef as ReactComponent };